// src/components/Navigation.js
import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import "../App.css";

function Navigation() {
    const [menuOpen, setMenuOpen] = useState(false);

    const openMenu = () => setMenuOpen(true);
    const closeMenu = () => setMenuOpen(false);

    return (
        <header className="navbar">
            <div className="container">
                <div className="nav-left-group">
                    <Logo />

                    {/* Hamburger button (only visible when menu is closed) */}
                    {!menuOpen && (
                        <button
                            className="menu-btn hamburger-btn"
                            onClick={openMenu}
                            aria-label="Open navigation menu"
                        >
                            <span className="bar"></span>
                            <span className="bar"></span>
                            <span className="bar"></span>
                        </button>
                    )}

                    {/* Close (X) button (only visible when menu is open) */}
                    {menuOpen && (
                        <button
                            className="menu-btn close-btn"
                            onClick={closeMenu}
                            aria-label="Close navigation menu"
                        >
                            ✕
                        </button>
                    )}

                    <nav className={`main-nav ${menuOpen ? "active" : ""}`}>
                        <ul className="nav-left">
                            <li><a href="product" onClick={closeMenu}>Product</a></li>
                            <li><a href="website-builder" onClick={closeMenu}>Website Builder</a></li>
                            <li><a href="solutions" onClick={closeMenu}>Solutions</a></li>
                            <li><a href="resources" onClick={closeMenu}>Resources</a></li>
                            <li><a href="pricing" onClick={closeMenu}>Pricing</a></li>
                        </ul>
                    </nav>
                </div>

                <div className="nav-right">
                    <Link to="/sales" className="btn btn-outline">Talk to Sales</Link>
                    <Link to="/book-demo" className="btn btn-primary btn-demo">Book Demo</Link>
                </div>
            </div>

            {menuOpen && <div className="nav-overlay" onClick={closeMenu}></div>}
        </header>
    );
}

export default Navigation;
